import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGift, faHeart, faStar } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next'
import { haptic, iconBurst } from '../../utils/fx'
import { PandaSign } from './PandaSign'

const c = 'panda-promo'

export const PandaPromo = ({ message }: { message: string }) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  function toggle(e: React.MouseEvent) {
    haptic()
    if (!open) iconBurst(e.clientX, e.clientY, [faStar, faGift, faHeart], 6)
    setOpen(!open)
  }

  return (
    <div className={`${c}${open ? ' is-open' : ''}`}>
      <button
        className={`${c}__btn`}
        onClick={toggle}
        aria-expanded={open}
        aria-label={t('PROMOTION')}
      >
        <PandaSign size={open ? 84 : 64} signKey={String(open)}>
          {open ? (
            <span role='status'>{message}</span>
          ) : (
            <>
              <FontAwesomeIcon icon={faGift} />
              {t('PROMOTION')}
            </>
          )}
        </PandaSign>
      </button>
    </div>
  )
}
